export const INDUSTRIES_ALL = 'common/industries/all'
export const INTERESTS_ALL = 'common/interests/all'
export const EVENTTYPES_ALL = 'common/eventTypes/all'
export const CONSULTANTS_ALL = 'common/consultants/all'
